import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import { 
  Box,
	Container, 
	Typography 
} from '@mui/material';

import NavBar from '../components/navbar/NavBar';
import Footer from '../components/footer/Footer';
import packageJson from "../../package.json"; 

//routes
import HomePage from '../views/homePage/HomePage';
import AboutPage from '../views/aboutPage/AboutPage';
import ContactPage from '../views/contactPage/ContactPage';
import PrivacyPolicyPage from '../views/privacyPolicyPage/PrivacyPolicyPage';
import TermsAndConditionsPage from '../views/termsAndConditionsPage/TermsAndConditionsPage';
// import ProductsPage from '../views/productsPage/ProductsPage';
import CapabilitiesPage from '../views/capabilitiesPage/CapabilitiesPage';
import SolutionsPage from '../views/solutionsPage/SolutionsPage';
import DevelopersPage from '../views/developersPage/DevelopersPage';
import SecurityPage from '../views/securityPage/SecurityPage';

import FeaturesPage from '../views/featuresPage/FeaturesPage';
import AccountsPayablePage from '../views/productsPage/accountsPayablePage/AccountsPayablePage';
import AccountsReceivablePage from '../views/productsPage/accountsReceivablePage/AccountsReceivablePage';
// import ExpenseManagementPage from '../views/productsPage/expenseManagementPage/ExpenseManagementPage';

import PricingPage from '../views/pricingPage/PricingPage';

import ChequesPage from '../views/chequesPage/ChequesPage';
import ChequeVerifyPage from '../views/chequeVerifyPage/ChequeVerifyPage';
import ComplaintsProcedurePage from '../views/complaintsProcedurePage/ComplaintsProcedurePage';

import DBEWaitlistPage from '../views/dbeWaitlistPage/DBEWaitlistPage';

import Aashto2026Page from '../views/aashto2026Page/Aashto2026Page';
import Icpa2026Page from '../views/icpa2026Page/Icpa2026Page';

import TradeSecureWaitlistPage from '../views/tradeSecureWaitlistPage/TradeSecureWaitlistPage';

import TradeSecurePage from '../views/tradeSecurePage/TradeSecurePage';
import PlatformArchitecturePage from '../views/platformArchitecturePage/PlatformArchitecturePage';
import RecoveryAndDefensePage from '../views/recoveryAndDefensePage/RecoveryAndDefensePage';
import CertifyPage from '../views/certifyPage/CertifyPage';
import ApplyPage from '../views/applyPage/ApplyPage';

const HIDDEN_NAVBAR_ROUTES = ['/aashto2026', '/aashto-2026', '/icpa2026', '/icpa-2026'];
const NO_FOOTER_ROUTES = ['/certify', '/apply', '/recovery-and-defense'];
const NO_GLOBAL_NAV_ROUTES = ['/certify', '/apply'];

const ConditionalNavBar = () => {
  const { pathname } = useLocation();
  if (NO_GLOBAL_NAV_ROUTES.includes(pathname)) return null;
  if (HIDDEN_NAVBAR_ROUTES.includes(pathname)) {
    return (
      <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
        <NavBar />
      </Box>
    );
  }
  return <NavBar />;
};

const ConditionalFooter = () => {
  const { pathname } = useLocation();
  if (NO_FOOTER_ROUTES.includes(pathname)) return null;
  return <Footer />;
};

const MainRoutes = () => {
  
  return (
    <Router>
			<ConditionalNavBar />
      <Box>
        <Routes>
          <Route path="/" element={<HomePage />}/>
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsAndConditionsPage />} />
          <Route path="/enterprise-access" element={<PricingPage />} />
          <Route path="/checks" element={<ChequesPage />} />
          <Route path="/checks/verify" element={<ChequeVerifyPage />} />
          <Route path="/file-complaint" element={<ComplaintsProcedurePage />} />

          <Route path="/trade-secure" element={<TradeSecurePage />} />
          <Route path="/platform-architecture" element={<PlatformArchitecturePage />} />
          <Route path="/recovery-and-defense" element={<RecoveryAndDefensePage />} />

          <Route path='/features' element={<FeaturesPage />} />
          <Route path="/accounts-payable" element={<AccountsPayablePage />} />
          <Route path="/accounts-receivable" element={<AccountsReceivablePage />} />
          {/* <Route path="/products/expense-management" element={<ExpenseManagementPage />} /> */}
          <Route path="/trade-secure-waitlist" element={<TradeSecureWaitlistPage />} />

          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/developers" element={<DevelopersPage />} />
          <Route path="/capabilities" element={<CapabilitiesPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/version" element={<AppVersion />} />

          <Route path="/dbe-waitlist" element={<DBEWaitlistPage />} />
          <Route path="/dbe-certification/virginia" element={<DBEWaitlistPage />} />

          <Route path="/aashto2026" element={<Aashto2026Page />} />
          <Route path="/aashto-2026" element={<Aashto2026Page />} />

          <Route path="/icpa2026" element={<Icpa2026Page />} />
          <Route path="/icpa-2026" element={<Icpa2026Page />} />

          <Route path="/certify" element={<CertifyPage />} />
          <Route path="/apply" element={<ApplyPage />} />

          <Route path="*" element={<NotFoundPage />}/>
        </Routes>
      </Box>
			<ConditionalFooter />
    </Router>
  )
}

export default MainRoutes;

// 404 page
const NotFoundPage = () => {
  return(
		<Container maxWidth="xl">
      <Box sx={{ height: "calc(100vh - 100px)" }} className="flexCenterCenterRow">
			  <Typography variant='h3'>404 - Page not found</Typography>
      </Box>
		</Container>
  )
};

const AppVersion = () => {
  return(
    <Box
      sx={{
        width: "100vw",
        height: "100vh", 
        position: "absolute", 
        zIndex: "1000",
        top: "0px",
        backgroundColor: "white"
      }}>
      <Typography
        color={"black"}>
        App version: {packageJson.version}
      </Typography>
    </Box>
  )
};